export default "__VITE_ASSET__DHHq0WcP__"